import { Vaccine } from './vaccine';
import { Pet } from './pet';
import { Vet } from './vet';
import { User } from './user';

/**
 * Vacinação
 */
export class Vaccination {
    /** ID da entidade no Firebase  */
    uuid?: string;
    /** Nome da vacina */
    primary_shot_date: any;
    /** Data de reforço */
    booster_shot_date: any;
    /** Animal */
    pet: Pet;
    /** Vacina */
    vaccine: Vaccine;
    /** Veterinario */
    vet: Vet;
    /** Usuário */
    user: User;
    /** Observações */
    notes: string;

    /**  */
    alert: boolean;
    /**  */
    alerttype: string;

    /**
     * Instanciar um
     * @param init - JSON que represente parcialmente as propriedades da classe
     */
    public constructor(init?: Partial<Vaccination>) {
        Object.assign(this, init);
    }
}
